import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import CompanyTool from '../tools/CompanyTool'
import routes from './../companies/default/router/routes'

import AllAlias from './../companies/default/views/AllAlias'
import PageNotFound from './../companies/default/views/404NotFound'

// Get routes
function overwriteRoutes()
{
    // Init variables
    let endRoutes = routes.list
    let confFile = CompanyTool.confFile()
    let companyRoutes = []

    // If there has not config file
    if (!confFile) {
        if (window.location.hostname == 'localhost' && CompanyTool.keyname == 'default') {
            return [{path: '/', component: AllAlias, name: 'all-alias'}]
        }
        return [{ path: "*", component: PageNotFound, name: '404' }]
    }

    // overwrite default routes with custom routes
    try {
        companyRoutes = require('./../companies/' + confFile.overwrite_folder + '/router/routes.js').default;
        let findIndexRoute = null
        companyRoutes.list.forEach((route) => {
            findIndexRoute = endRoutes.findIndex((endRoute) => endRoute.name == route.name)
            if (findIndexRoute != -1) {
                endRoutes[findIndexRoute] = route
            } else {
                endRoutes.splice(-1, 0, route)
            }
        })
    } catch (e) {
    }

    // Overwrite route with url_keyname prefix
    if (!CompanyTool.inDomainName() && confFile) {
        endRoutes.forEach((route) => {
            if (route.name != '404') {
                route.path = '/' + confFile.url_keyname + route.path
            }
        })
    }

    // Return all routes
    return endRoutes
}

// Init router
var router = new Router({
    mode: 'history',
    routes: overwriteRoutes()
})

// Action before each route
router.beforeEach(async (to, from, next) => {
    // Scroll at the top
    window.scrollTo(0, 0);

    if (CompanyTool.confFile() && CompanyTool.confFile().blocked == 1 && to.name != 'blocked') {
        next({name: 'blocked'})
    }

    // Init localStorage before each alias changement
    if (to.name !== '404' && (!localStorage.getItem('companie') || localStorage.getItem('companie') != CompanyTool.keyname)) {
        localStorage.removeItem('form-data')
        localStorage.removeItem('langage')
        localStorage.setItem('companie', CompanyTool.keyname)
    }

    // Continue
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js